module.exports = __webpack_public_path__ + "static/media/user1.8e68f486.jpg";